import React, {Suspense} from "react";
import type {ViewVariationProps} from './ViewVariation'

import { ErrorBoundary } from "react-error-boundary";

import {TreeDummyLoading} from '../../components/TreeDummyLoading';


const ViewVariation = React.lazy(() => import(/* webpackPrefetch: 1, webpackChunkName: "ViewVariation" */ './ViewVariation'));


export const SharedDynamicViewVariation = (props: ViewVariationProps) => {
    return (
        <Suspense fallback={<TreeDummyLoading/>}>
            <ErrorBoundary fallback={<ViewVariation {...props} />}>
                <ViewVariation {...props} />
            </ErrorBoundary>
        </Suspense>
    )
}
